import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ResourceInfoPopover from '../../common/ResourceInfoPopover';
import { TruncatedTitle } from '../../common/TruncatedTitle';
import { RESOURCE_LABEL } from '../../common/constants';

function DeckHeader({ deck }) {
  const navigate = useNavigate();

  return (
    <Box className="resourceHeader" id="deckDetails__box_header">
      <Box className="resourceTitleGroup">
        <Box className="resourceTitle">
          <TruncatedTitle
            id="deckDetails__text_title"
            variant="h2"
            component="h1"
            name={deck.title}
          />
          <ResourceInfoPopover
            id="deckDetails__button_info"
            name={deck.title}
            nameLabel={RESOURCE_LABEL.FLASHCARD_DECK}
            resources={deck.resources}
            lastEditedBy={deck.lastEditedBy}
          />
        </Box>
        <Typography className="resourceCount">
          <strong>{deck.cards?.length ?? 0}</strong> cards
        </Typography>
      </Box>

      <Box className="resourceActions resourceActions--stack">
        <Button
          variant="contained"
          className="mss__button"
          id="deckDetails__button_edit"
          onClick={() => navigate('edit')}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          className="mss__button primary"
          id="deckDetails__button_study"
          onClick={() => navigate('study')}
        >
          Study
        </Button>
      </Box>
    </Box>
  );
}

export default DeckHeader;
